import { fileImportApi } from "@/main/api";
import { KOGTableCell, KOGTableRow } from "@/main/components/shared/kogBoxGrid/styles";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import { TextEllipsis } from "@/main/components/shared/styles";
import { TermsOfUseResponse } from "@/main/models/response";
import { getTranslateByKey } from "@/main/services/utils";
import { downloadPdfFile } from "@/main/services/utilsFile";
import Download from "@mui/icons-material/Download";
import Edit from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import { useState } from "react";
import * as S from "./styles";

interface IRowTermsOfuse {
	index: number;
	term: TermsOfUseResponse;
	handleEdit: (fileImportGuid: string) => void;
}
export default function RowTermsOfUse({ index, term, handleEdit }: Readonly<IRowTermsOfuse>) {
	const [isDownloading, setIsDownloading] = useState<boolean>(false);
	function handleDownload() {
		setIsDownloading(true);
		fileImportApi
			.getFileImport(term.fileImportGuid)
			.then((res) => {
				const { result } = res.data;

				if (result) {
					downloadPdfFile(result, term.fileImportName);
				}
			})
			.finally(() => {
				setIsDownloading(false);
			});
	}
	return (
		<KOGTableRow $isSizeLong $notHover $notClickable id={`id-searchTermsOfUse-row-${index}`}>
			<KOGTableCell>
				<TextEllipsis title={term.companies}>{term.companies}</TextEllipsis>
			</KOGTableCell>
			<KOGTableCell>
				<TextEllipsis title={term.fileTypeName}>{term.fileTypeName}</TextEllipsis>
			</KOGTableCell>

			<KOGTableCell>
				<TextEllipsis title={term.status}>{term.status}</TextEllipsis>
			</KOGTableCell>

			<KOGTableCell align="center">
				<S.Actions>
					<IconButton
						id={`id-searchTermsOfUse-icon-edit-${term.fileImportGuid}`}
						title={getTranslateByKey("information.edit")}
						onClick={() => handleEdit(term.fileImportGuid)}
					>
						<Edit />
					</IconButton>
					<S.IconWrapper>
						<IconButton
							disabled={isDownloading}
							id={`id-searchTermsOfUse-icon-download-${term.fileImportGuid}`}
							title={getTranslateByKey("information.downloadFile")}
							onClick={() => handleDownload()}
						>
							{isDownloading ? <LoadingComponent size={16} /> : <Download />}
						</IconButton>
					</S.IconWrapper>
				</S.Actions>
			</KOGTableCell>
		</KOGTableRow>
	);
}
